import { render, staticRenderFns } from "./CmgViewDetailModal.vue?vue&type=template&id=47574f04&scoped=true&lang=pug"
import script from "./cmg-view-detail-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-view-detail-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgViewDetailModal.vue?vue&type=style&index=0&id=47574f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47574f04",
  null
  
)

export default component.exports